import { ResourceType } from "@/services/order";
import { request } from "@umijs/max";

export interface IResourceInfo {
  /** 今天已使用 */
  powerDayUsed: number;
  /** 本月已使用 */
  powerMonthUsed: number;
  /** 剩余动能值 */
  powerRemain: number;
  /** 生效机器人 */
  robotValid: number;
  /** 到期机器人 */
  robotInvalid: number;
  /** 已用机器人额度 */
  robotUsed: number;
  /** 剩余机器人额度 */
  robotRemain: number;
  /** 付费机器人 */
  robotPaid: number;
  /** 可用席位 */
  seatAll: number;
  /** 已用席位 */
  seatUsed: number;
  /** 剩余席位 */
  seatRemain: number;
  /** 付费席位 */
  seatPaid: number;
  /** 到期席位 */
  seatInvalid: number;
  /** 本月已使用运营消息额度 */
  operationMessageMonthUsed: number;
  /** 本月可使用运营消息总额 */
  operationMessageMonthTotal: number;
  /** 本月剩余运营消息额度 */
  operationMessageMonthRemain: number;

  balanceInfo: {
    /** 充值金额 */
    cashBalance: number;
    /** 保证金 */
    depositBalance: number;
    /** 赠送金额 */
    giftBalance: number;
    /** 用户类型 */
    level: "PERSON" | "ORG";
    /** 总金额 */
    totalBalance: number;
    /** 未结清 */
    unclearedAmount: number;
    /** 可用额度 */
    canUseBalance: number;
  };
}

/**
 * 查询资源情况
 * @returns
 */
export const getResourceInfo = () => {
  return request<API.BaseResponse<IResourceInfo>>(
    `/api/damselfish-fee-center/userSearch/userInfo`
  );
};

export enum PowerSourceTypeEnum {
  /** 购买 */
  USER_PAY = "USER_PAY",
  /** 赠送 */
  PROVIDED = "PROVIDED",
  /** 消耗 */
  CONSUME_AUTO = "CONSUME_AUTO",
  /** 获得 */
  OBTAINED = "OBTAINED",
}

export enum StatusEnum {
  /** 生效 */
  ENABLE = "ENABLE",
  /** 到期 */
  DISABLE = "DISABLE",
}

export enum SortEnum {
  /** 升序 */
  ASC = "ASC",
  /** 降序 */
  DESC = "DESC",
}

export interface IRequestDetailData {
  pageNum: number;
  pageSize: number;
  powerSource: `${PowerSourceTypeEnum}`;
  robotStatus: `${StatusEnum}`;
  sort: `${SortEnum}`;
  startTime: string;
  endTime: string;
}

interface IPaginationResponse<T> {
  records: T[];
  total: number;
  current: number;
  size: number;
  pages: number;
}

/**
 * 查询动能值明细
 * @returns
 */
export const postPowerDetail = (data: Partial<IRequestDetailData>) => {
  return request<
    API.BaseResponse<
      IPaginationResponse<{
        nums: number;
        powerSource: `${PowerSourceTypeEnum}`;
        buyDate: string;
      }>
    >
  >("/api/damselfish-fee-center/userSearch/powerPage", {
    method: "POST",
    data,
  });
};

/**
 * 导出动能值明细 url
 * @param data
 */
export const getExportPowerDetailUrl = (data: Partial<IRequestDetailData>) => {
  const queryStr = Object.entries(data)
    .map(([key, value]) => `${key}=${value}`)
    .join("&");
  return "/api/damselfish-fee-center/userSearch/powerPage/export?" + queryStr;
};

/**
 * 查询机器人明细
 * @returns
 */
export const postAppDetail = (data: Partial<IRequestDetailData>) => {
  return request<
    API.BaseResponse<
      IPaginationResponse<{
        avatar: string;
        detailStatus: `${StatusEnum}`;
        endTime: string;
        groupName: string;
        name: string;
        resourceId: string;
      }>
    >
  >("/api/damselfish-fee-center/userSearch/robotPage", {
    method: "POST",
    data,
  });
};

export enum SeatTermTypeEnum {
  /** 长效 */
  LONG = "LONG",
  /** 短效 */
  SHORT = "SHORT",
}

export enum RenewalFlagEnum {
  /** 开启 */
  AUTO_RENEWAL = "AUTO_RENEWAL",
  /** 关闭 */
  MANUAL_RENEWAL = "MANUAL_RENEWAL",
}

/**
 * 查询席位明细
 * @returns
 */
export const postSeatDetail = (data: Partial<IRequestDetailData>) => {
  return request<
    API.BaseResponse<
      IPaginationResponse<{
        detailStatus: `${StatusEnum}`;
        endTime: string;
        name: string;
        resourceId: string;
        termType: SeatTermTypeEnum;
        renewalFlag: RenewalFlagEnum;
      }>
    >
  >("/api/damselfish-fee-center/userSearch/seatPage", {
    method: "POST",
    data,
  });
};

export const getDefaultSeatRenewalFlagService = () => {
  return request<API.BaseResponse<{ renewalFlag: RenewalFlagEnum }>>(
    "/api/damselfish-fee-center/renewal/getConfig",
    {
      method: "POST",
      data: {
        resourceType: ResourceType.ENTERPRISE_WECHAT_SEAT,
      },
    }
  );
};

export const updateSeatRenewalFlagService = (data: {
  resourceId?: string;
  renewalFlag: RenewalFlagEnum;
}) => {
  return request<API.BaseResponse<null>>(
    "/api/damselfish-fee-center/renewal/saveConfig",
    {
      method: "POST",
      data: {
        resourceId: data.resourceId,
        renewalFlag: data.renewalFlag,
        resourceType: ResourceType.ENTERPRISE_WECHAT_SEAT,
      },
    }
  );
};
